<script lang="ts">
	import { ETheme } from '$lib/dto/ETheme';
	import { appTheme } from '$lib/utils/themeUtils';
	import NavUserDropdown from './NavUserDropdown.svelte';

	export let translucent = false;
	export let roundedTop = false;
	export let showLogo = true;

	let clazz = '';
	export { clazz as class };
</script>

<nav
	class:rounded-t={roundedTop}
	class="w-full antialiased {translucent
		? 'bg-transparent'
		: 'border-b border-[#eee] bg-white dark:border-[#111] dark:bg-[#1e1b1d]'} {clazz}"
>
	<div class="flex flex-wrap items-center justify-between p-1.5 pl-2">
		{#if showLogo}
			<div class="mr-6 flex flex-shrink-0 items-center">
				<a href="/" class="whitespace-no-wrap align-baseline">
					<img
						width="106"
						src={$appTheme == ETheme.Dark
							? '/images/codelantis-logo-white.svg'
							: '/images/codelantis-logo-black.svg'}
						alt="Codelantis"
					/>
				</a>
			</div>
		{/if}

		<div class="flex-1"></div>
		<NavUserDropdown />
	</div>
</nav>
